export class ResumoHomologacaoCurso {

    public observacao?: string;
    public id_usuario_emissor: number;
    public data_julgamento: Date;
    public id_homologacao: number;
    public id_situacao: number;
    public nome_perfil: string;
    public decisao?: boolean;

}


// WEBPACK FOOTER //
// ./src/app/entity/resumo-homologacao.model.ts